/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { Table, Grid, Row, Col, FormGroup, ControlLabel, Button } from 'react-bootstrap';
import Select from 'react-select';
import Toggle from 'react-toggle';

import { PropTypes } from 'prop-types';
import { LoadingSpinner } from '../../LoadingSpinner';
import { ComparisonHelper } from '../../helpers/ComparisonHelper';
import { TableButton } from '../../TableButton';
import { PopoverForm } from "./PopoverForm";
import { SortHelper } from "../../helpers/SortHelper";

export class PassingTimesActive extends Component {
    static contextTypes = {
        edition: PropTypes.object
    }

    constructor(props) {
        super(props);

        this.state = {
            showAsInput: "no-id",
            viewAllSchedules: false,
        }
    }

    toggleViewAllSchedules() {
        const { viewAllSchedules } = this.state;

        this.setState({
            viewAllSchedules: !viewAllSchedules
        });
    }

    handleLineSelected(e) {
        this.setState({ showAsInput: "no-id" });
        this.props.handleLineSelected(e);

        this.props.handlePathSelected(null);
        this.props.handleScheduleSelected(null);
    }

    handlePathSelected(e) {
        this.setState({ showAsInput: "no-id" });
        this.props.handlePathSelected(e)
    }

    handleScheduleSelected(e) {
        this.setState({ showAsInput: "no-id" });
        this.props.handleScheduleSelected(e);
    }

    renderFormatedHour(value) {
        if (value === ":" || value === "undefined:NaN") {
            return "";
        }

        return value;
    }

    getPassingKey(tripName, passing) {
        if (undefined === passing) {
            return parseInt(`${Math.random() * 1000000}`, 10);
        }

        if (undefined !== passing.id) {
            return passing.id;
        }

        if ("object" === typeof tripName) {
            return `${tripName.right}-${passing.pathStop.stopOrder.right}`;
        }

        return `${tripName}-${passing.pathStop.stopOrder.right}`;
    }

    getStopNameTitle(stopName) {
        if ("object" !== typeof stopName) {
            return stopName;
        }

        if (undefined === stopName.left) {
            return `[RASCUNHO] ${stopName.right}`;
        }

        return `${stopName.left} -> ${stopName.right}`;
    }

    getStopOrder(stopOrder) {
        if ("object" !== typeof stopOrder) {
            return stopOrder;
        }

        return stopOrder.right;
    }

    handleOnClick(passing) {
        this.setState({
            showAsInput: undefined !== passing.id ? passing.id : "no-id"
        });
    }

    renderPathStops(pathSelectedPathStops, tablePassings) {
        if (undefined === pathSelectedPathStops) {
            return null;
        }

        return (
            pathSelectedPathStops.map((pathStop, idx) =>
                <tr className="pst_tr_stops" key={`path-stop-${idx}`}>
                    <th className="pst_td_stops" title={this.getStopNameTitle(pathStop.stop.name)}>[{ComparisonHelper.renderProperty(pathStop.stop.code)}] {ComparisonHelper.renderProperty(pathStop.stop.name)}</th>
                    {undefined !== tablePassings[this.getStopOrder(pathStop.stopOrder)] ? tablePassings[this.getStopOrder(pathStop.stopOrder)].elements : null}
                </tr>
            )
        );
    }

    renderTable() {
        const { pathTrips, scheduleSelected } = this.props;

        if (undefined === pathTrips || undefined === scheduleSelected) {
            return null;
        }

        const { loadingTrips } = this.props;

        if (loadingTrips) {
            return (<LoadingSpinner />);
        }

        const { showAsInput } = this.state;
        const { pathSelectedPathStops, editTripName, selectedPassing } = this.props;
        const tablePathTrips = [];
        const tablePassings = [];

        const closable = pathTrips.length > 0;
        let tabIndex = 10;
        pathTrips.forEach((pt, i) => {
            if (pt !== undefined) {
                if (pt.id > 0) {
                    if (pt.id === editTripName) {
                        tablePathTrips.push(
                            <th className="pst_th_trips" title={pt.name} key={`pathTrip-${i}`}>
                                {closable ? <a className={pt.wasReplaced ? "pst_a_delete_disabled" : "pst_a_delete"} onClick={(e) => this.props.handleDeleteClick(pt, "active")}>X</a> : null}
                                <input className="pst_input" type="text" value={pt.name} onChange={(e) => this.props.onChangeTripName(pt.id, e)} />
                            </th>
                        );
                    } else {
                        tablePathTrips.push(
                            <th className="pst_th_trips" title={pt.name} key={`pathTrip-${i}`}>
                                <PopoverForm
                                    pt={pt}
                                    handleIntervalsClick={(a) => this.props.handleIntervalsClick(a, "active")}
                                    handleMoveClick={(a) => this.props.handleMoveClick(a, "active")}
                                    handleCopyClick={(a) => this.props.handleCopyClick(a, "active")}
                                    handleNotesClick={(a) => this.props.handleNotesClick(a, "active")}>
                                    <TableButton id={`TableButton-${pt.id}`} icon="icon-config-layouts" title="Opções" />
                                </PopoverForm>
                                {closable ? <a className={pt.wasReplaced ? "pst_a_delete_disabled" : "pst_a_delete"} onClick={(e) => this.props.handleDeleteClick(pt, "active")}>X</a> : null}
                                <span className="pst_span" onDoubleClick={(e) => this.props.onDoubleClickTrip(pt.id, e)}>{pt.name}</span>
                            </th>
                        );
                    }
                } else {
                    if ("object" === typeof pt.name) {
                        const hasLeftValue = undefined !== pt.name.left
                        tablePathTrips.push(
                            <th className={`pst_th_trips ${!hasLeftValue ? "comparison-new-value" : ""}`} title={pt.name.right} key={`pathTrip-${i}`}>
                                <span className={`pst_span ${!hasLeftValue ? "comparison-right-value" : ""}`} onDoubleClick={!hasLeftValue ? null : (e) => this.props.onDoubleClickTrip(pt.id, e)}>{pt.name.right}</span>
                            </th>
                        );
                    }
                    else {
                        tablePathTrips.push(
                            <th className="pst_th_trips" title={pt.name} key={`pathTrip-${i}`}>
                                {closable && "object" !== typeof pt.name ? <a className="pst_a_delete" onClick={(e) => this.props.handleDeleteClick(pt, "active")}>X</a> : null}
                                <input className="pst_input" type="text" value={pt.name} placeholder="Nome" onChange={(e) => this.props.onChangeTripName(pt.id, e)} />
                            </th>
                        );
                    }
                }

                let passingsArr = pt.passings;
                if (!Array.isArray(passingsArr)) {
                    passingsArr = ComparisonHelper.compare(
                        undefined === passingsArr.left ? [] : passingsArr.left.map(passing => Object.assign({ stop: pathSelectedPathStops.find(ps => ps.id === passing.pathStop.id).stop }, passing)),
                        passingsArr.right,
                        {
                            match: [{ left: "pathStop.stopOrder", right: "pathStopOrder" }],
                            fields: [{ left: "formatedHour", right: "formatedHour" }, { left: "pathStop.id", right: "pathStopId" }]
                        });
                }
                else {
                    passingsArr = passingsArr.map(passing => Object.assign({ stop: this.getPassingStop(pathSelectedPathStops, passing) }, passing));
                }

                if (Array.isArray(passingsArr)) {
                    if (passingsArr.length < pathSelectedPathStops.length) {
                        for (let psIdx in pathSelectedPathStops) {
                            const pathStop = pathSelectedPathStops[psIdx];
                            const stopOrderToCompare = "object" !== typeof pathStop.stopOrder ? pathStop.stopOrder : pathStop.stopOrder.right;

                            if (undefined === passingsArr.find(passing => stopOrderToCompare === passing.pathStop.stopOrder || stopOrderToCompare === passing.pathStop.stopOrder.right)) {
                                passingsArr.push({
                                    pathStop: {
                                        stopOrder: stopOrderToCompare
                                    },
                                    formatedHour: "object" !== typeof pt.name && "object" !== typeof pathStop.stop.name ? "" : { left: undefined, right: "" }
                                });
                            }
                        }
                    }

                    passingsArr.forEach((pass, idx) => {
                        if (pass.pathStop.stopOrder !== undefined) {
                            let pathStopOrder = pass.pathStop.stopOrder;
                            if ("object" === typeof pathStopOrder) {
                                pathStopOrder = pathStopOrder.right;
                            }

                            let passingCell = null;
                            if ("object" === typeof pass.formatedHour && showAsInput !== pass.id) {
                                passingCell =
                                    <td className="pst_td" key={`compared-passings-${this.getPassingKey(pt.name, pass)}`} onClick={() => this.handleOnClick(pass)}>
                                        {ComparisonHelper.renderProperty(pass.formatedHour, this.renderFormatedHour)}
                                    </td>;
                            }
                            else {
                                let formatedHour =
                                    showAsInput === pass.id ?
                                        undefined !== pass.formatedHour.left ?
                                            pass.formatedHour.left :
                                            pass.formatedHour :
                                        pass.formatedHour;

                                let passingId = pass.id;
                                if (undefined === passingId) {
                                    passingId = -idx * Math.random();
                                }

                                passingCell =
                                    <td className="pst_td" key={`passings-${passingId}`} onClick={() => this.handleOnClick(pass)}>
                                        <input className="pst_input text-align-center"
                                            type="text"
                                            tabIndex={tabIndex + pathStopOrder}
                                            value={this.renderFormatedHour(formatedHour)}
                                            placeholder="HH:mm"
                                            onChange={(e) => this.props.onChangePassValue(pass.id, e)} />
                                        {this.props.showPropBtn && selectedPassing !== undefined && selectedPassing.id === pass.id ? <Button className="propagate-btn" onClick={() => this.props.onClickPropagateBtn()}>P</Button> : null}
                                    </td>;
                            }

                            if (undefined !== tablePassings[pathStopOrder]) {
                                tablePassings[pathStopOrder].elements.push(passingCell);
                            } else {
                                tablePassings[pathStopOrder] = {
                                    stopOrder: pathStopOrder,
                                    elements: [passingCell]
                                };
                            }
                        }
                    });

                    tabIndex += pathSelectedPathStops.length;
                }
            }
        });

        tablePathTrips.push(
            <th className="pst_th_insert" key={`pathTrip-new`}>
                <Button bsSize="small" className="pull-left table-btn" onClick={() => this.props.handleCreateClick()}>
                    <div className="icon-plus icon-img pst_a_insert"></div>
                </Button>
            </th>
        );

        return (
            <Row className="pst-table-wrapper-row">
                <Col className="pst-col-pst-table" sm={12}>
                    <Table responsive striped hover>
                        <thead>
                            <tr className="pst_tr_stops_header">
                                <th className="pst_th_stops">PARAGEM</th>
                                {tablePathTrips}
                            </tr>
                        </thead>
                        <tbody>
                            {this.renderPathStops(pathSelectedPathStops, tablePassings)}
                        </tbody>
                    </Table >
                </Col>
            </Row>
        );
    }

    getPassingStop(pathSelectedPathStops, passing) {
        const pathStop = pathSelectedPathStops.find(ps => ps.id === passing.pathStop.id);

        if (undefined === pathStop) {
            return undefined;
        }

        return pathStop.stop;
    }

    getScheduleName(schedule, edition) {
        return `${schedule.name} ««${edition.getPlanningEditionName(schedule.planningEdition)}»»`;
    }

    renderSchedules() {
        const { viewAllSchedules } = this.state;
        const { pathSelected } = this.props;

        if (undefined === pathSelected) {
            return null;
        }

        const { loadingPathStops } = this.props;

        if (loadingPathStops) {
            return (<LoadingSpinner />);
        }

        const { edition } = this.context;
        const { schedules, scheduleSelected } = this.props;
        const schedulesToRender = viewAllSchedules ?
            schedules :
            schedules.filter(s => s === scheduleSelected || s.paths.filter(p => p.id === pathSelected.id).length > 0);

        return (
            <FormGroup controlId="formSchedules">
                <Row className="row-dropdown">
                    <Col sm={1}>
                        <ControlLabel className="control-label-dropdown">Horário</ControlLabel>
                    </Col>
                    <Col sm={9}>
                        <Select
                            className="custom-multiselect"
                            placeholder="Selecione um horário..."
                            noOptionsMessage={() => "Sem Horários Configurados"}
                            onChange={(e) => this.handleScheduleSelected(e)}
                            options={schedulesToRender}
                            isMulti={false}
                            isClearable={true}
                            getOptionValue={value => value.id}
                            getOptionLabel={label => this.getScheduleName(label, edition)}
                            value={undefined === scheduleSelected ? null : scheduleSelected}
                        />
                    </Col>
                    <Col sm={2}>
                        <label>
                            <Toggle className="comparison-toggle"
                                checked={viewAllSchedules}
                                icons={false}
                                onChange={() => this.toggleViewAllSchedules()} />
                            <span>VER TODOS OS HORÁRIOS DISPONÍVEIS</span>
                        </label>
                    </Col>
                </Row>
            </FormGroup>
        );
    }

    renderPaths() {
        const { linePaths } = this.props;

        if (0 === linePaths.length) {
            return null;
        }

        const { loadingLines } = this.props;

        if (loadingLines) {
            return (<LoadingSpinner />);
        }

        const { pathSelected } = this.props;

        return (
            <FormGroup controlId="formPaths">
                <Row className="row-dropdown">
                    <Col sm={1}>
                        <ControlLabel className="control-label-dropdown">Percurso</ControlLabel>
                    </Col>
                    <Col sm={11}>
                        <Select
                            className="custom-multiselect"
                            placeholder="Selecione um percurso..."
                            noOptionsMessage={() => "Sem Percursos Configurados"}
                            onChange={(e) => this.handlePathSelected(e)}
                            options={linePaths}
                            isMulti={false}
                            isClearable={true}
                            getOptionValue={value => value.id}
                            getOptionLabel={label => label.code}
                            value={undefined === pathSelected ? null : pathSelected}
                        />
                    </Col>
                </Row>
            </FormGroup>
        );
    }

    render() {
        const { lines, lineSelected, loadingLines, scheduleSelected } = this.props;

        if (loadingLines) {
            return <LoadingSpinner />;
        }

        return (
            <Grid fluid>
                <FormGroup className="margin-top-15" controlId="formLine">
                    <Row className="row-dropdown">
                        <Col sm={1}>
                            <ControlLabel className="control-label-dropdown">Linha</ControlLabel>
                        </Col>
                        <Col sm={11}>
                            <Select
                                className="custom-multiselect"
                                placeholder="Selecione uma linha..."
                                noOptionsMessage={() => "Sem Linhas Configuradas"}
                                onChange={(e) => this.handleLineSelected(e)}
                                options={lines.sort(SortHelper.defaultLineSorter)}  // ascending order
                                isMulti={false}
                                isClearable={true}
                                getOptionValue={value => value.id}
                                getOptionLabel={label => `${label.code} | ${label.goName}`}
                                value={lineSelected}
                            />
                        </Col>
                    </Row>
                </FormGroup>

                {this.renderPaths()}
                {this.renderSchedules()}
                {scheduleSelected && lineSelected && lineSelected.lastImportDate !== undefined &&
                    <Row style={{ marginBottom: '8px' }}>
                        <Col sm={12}>
                            <small className="text-muted" style={{ marginLeft: '20px'}}>
                                {(() => {
                                    const d = new Date(lineSelected.lastImportDate);
                                    const pad = n => String(n).padStart(2, '0');
                                    return `Entrada em vigor da última atualização: ${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()}`;
                                })()}
                            </small>
                        </Col>
                    </Row>
                }
                {this.renderTable()}
            </Grid>
        );
    }
}
